import * as actions from './actions';

const initialState = {
    user: null,
    loggedIn: false,
    isFetching: false,
    registerSuccess: false,
    noAuthToken: false,
    error: '',
};

export default function auth(state = initialState, action) {
    switch (action.type) {
        case actions.LOGIN_START:
            return {
                ...state,
                isFetching: true,
                error: '',
            };
        case actions.LOGIN_SUCCESS:
            return {
                ...state,
                user: action.payload,
                loggedIn: true,
                isFetching: false,
            };
        case actions.LOGIN_FAIL:
            return {
                ...state,
                loggedIn: false,
                isFetching: false,
                error: action.error,
            };
        case actions.LOGOUT_START:
            return {
                ...state,
                isFetching: true,
                error: '',
            };
        case actions.LOGOUT_SUCCESS:
            return {
                ...state,
                ...initialState,
            };
        case actions.REGISTER_START:
            return {
                ...state,
                isFetching: true,
                error: '',
            };
        case actions.REGISTER_SUCCESS:
            return {
                ...state,
                registerSuccess: true,
                isFetching: false,
            };
        case actions.REGISTER_FAIL:
            return {
                ...state,
                registerSuccess: false,
                isFetching: false,
                error: action.error,
            };
        case actions.CLEAR_AUTH_ERRORS:
            return {
                ...state,
                error: '',
            }
        case actions.NO_AUTH_TOKEN:
            return {
                ...state,
                noAuthToken: true,
            }
        default:
            return state;
    }
}